import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../constants/api';
import { useLanguage } from '../../contexts/LanguageContext';

// Global kill-switch for /register — useful to lock out new external users
// while the team is mid-change on the platform, without touching existing
// accounts or logins. Reads/writes the same flag the public register page
// checks (GET /settings/registration-status, POST /admin/settings/registration).
const AdminRegistrationToggle = () => {
  const { t } = useLanguage();
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const fetchStatus = async () => {
    try {
      const { data } = await axios.get(`${API}/settings/registration-status`);
      setEnabled(data.enabled !== false);
    } catch (error) {
      console.error('Error loading registration status:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
  }, []);

  const handleToggle = async () => {
    const next = !enabled;
    setSaving(true);
    setError('');
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${API}/admin/settings/registration`,
        { enabled: next },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setEnabled(next);
    } catch (err) {
      console.error('Error updating registration status:', err);
      setError(err?.response?.data?.detail || t('adminRegToggle.saveError', 'No se pudo guardar el cambio. Intenta de nuevo.'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white card-shadow-lg rounded-xl p-4 mb-6" style={{ maxWidth: 320 }}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <h3 className="text-sm font-semibold text-black">{t('adminRegToggle.title', 'Registro de usuarios')}</h3>
          <p className="text-gray-500 text-xs mt-0.5">
            {loading ? t('adminRegToggle.loading', 'Cargando...') : enabled ? t('adminRegToggle.active', 'Activo') : t('adminRegToggle.disabled', 'Desactivado')}
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          disabled={loading || saving}
          onClick={handleToggle}
          style={{
            position: 'relative',
            width: 34,
            height: 20,
            borderRadius: 980,
            border: 'none',
            background: enabled ? '#22C55E' : '#D1D5DB',
            cursor: loading || saving ? 'not-allowed' : 'pointer',
            opacity: loading || saving ? 0.6 : 1,
            transition: 'background .2s ease',
            flexShrink: 0,
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: 2,
              left: enabled ? 16 : 2,
              width: 16,
              height: 16,
              borderRadius: '50%',
              background: '#fff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
              transition: 'left .2s ease',
            }}
          />
        </button>
      </div>
      {error && (
        <p className="text-sm mt-3" style={{ color: '#DC2626' }}>{error}</p>
      )}
    </div>
  );
};

export default AdminRegistrationToggle;
